import { COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX, COMMUNICATION_CHART_NODE_STYLE } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
import { COMMUNICATION_CHART_MOTION } from '@web/components/CommunicationNetworkGraph/graph/communicationChartMotion';
import { isCommunicationChartEmployeeSectionLabelsActive, resolveCommunicationChartEmployeeSectionLabelPaddingPx } from '@web/components/CommunicationNetworkGraph/graph/drawCommunicationChartEmployeeSectionLabels';
export var COMMUNICATION_CHART_VIEWPORT_PADDING_PX = 56;
var resolveCommunicationChartNodeViewportRadius = function (node) {
    var _a;
    var dataSize = Number((_a = node.data('nodeSize')) !== null && _a !== void 0 ? _a : 0);
    var renderedSize = Math.max(node.width(), node.height(), dataSize);
    return ((renderedSize / 2) * COMMUNICATION_CHART_MOTION.hoverScale +
        COMMUNICATION_CHART_NODE_STYLE.ringWidth);
};
var HUB_SATELLITE_LABEL_MARGIN_PX = 4;
var resolveCommunicationChartNodeLabelExtensionPx = function (node) {
    if (node.hasClass('teamHubSatellite')) {
        return (HUB_SATELLITE_LABEL_MARGIN_PX +
            COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX +
            2);
    }
    if (node.hasClass('orgTeam')) {
        return 16;
    }
    return 0;
};
var resolveCommunicationChartNodeLabelAboveExtensionPx = function (node) { return (node.hasClass('employeeFocusPerson') ? 16 : 0); };
/** Fit viewport to all node positions, including hidden org-team hub satellites. */
export var fitCommunicationChartViewport = function (cy, paddingPx) {
    if (paddingPx === void 0) { paddingPx = COMMUNICATION_CHART_VIEWPORT_PADDING_PX; }
    var nodes = cy.nodes();
    if (nodes.empty()) {
        return;
    }
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    nodes.forEach(function (node) {
        var _a = node.position(), x = _a.x, y = _a.y;
        var radius = resolveCommunicationChartNodeViewportRadius(node);
        var labelExtensionPx = resolveCommunicationChartNodeLabelExtensionPx(node);
        var labelAboveExtensionPx = resolveCommunicationChartNodeLabelAboveExtensionPx(node);
        minX = Math.min(minX, x - radius);
        maxX = Math.max(maxX, x + radius);
        minY = Math.min(minY, y - radius - labelAboveExtensionPx);
        maxY = Math.max(maxY, y + radius + labelExtensionPx);
    });
    if (isCommunicationChartEmployeeSectionLabelsActive(cy)) {
        maxY += resolveCommunicationChartEmployeeSectionLabelPaddingPx();
    }
    var bboxW = maxX - minX;
    var bboxH = maxY - minY;
    if (bboxW <= 0 || bboxH <= 0) {
        cy.fit(nodes, paddingPx);
        return;
    }
    var containerW = cy.width();
    var containerH = cy.height();
    var paddedW = bboxW + paddingPx * 2;
    var paddedH = bboxH + paddingPx * 2;
    var zoom = Math.min(containerW / paddedW, containerH / paddedH, cy.maxZoom());
    var clampedZoom = Math.max(zoom, cy.minZoom());
    var centerX = (minX + maxX) / 2;
    var centerY = (minY + maxY) / 2;
    cy.viewport({
        zoom: clampedZoom,
        pan: {
            x: containerW / 2 - centerX * clampedZoom,
            y: containerH / 2 - centerY * clampedZoom
        }
    });
};
